import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDfHSxkcIcUjRQmeMo8LjKB424e7sixypA",
    authDomain: "english-typing-248c6.firebaseapp.com",
    projectId: "english-typing-248c6",
    storageBucket: "english-typing-248c6.firebasestorage.app",
    messagingSenderId: "333609137318",
    appId: "1:333609137318:web:0ba49fbdcac8fa768cf067",
};

export const isConfigValid = firebaseConfig.apiKey && !firebaseConfig.apiKey.includes("YOUR_API_KEY");
export const appId = 'typeflow-v1';

let app, auth, db;
if (isConfigValid) {
    try {
        app = initializeApp(firebaseConfig);
        auth = getAuth(app);
        db = getFirestore(app);
    } catch (e) {
        console.error("Firebase init error:", e);
    }
}

export { app, auth, db };
